export default class {
  constructor({ selector }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelectorAll(selector)
    this.changeEvent = new Event('change')
    //Methods
    this.create()

  }

  addBtnEventlistener(btn, list) {
    btn.addEventListener('click', () => {
      list.classList.toggle('dropdown__list_visible')
      btn.classList.toggle('active')
    })
  }

  addItemEventlistener(list, item, btn, input, items) {
    item.addEventListener('click', (e) => {
      items.forEach((el) => el.classList.remove('active'))
      e.target.classList.add('active')
      btn.innerText = item.innerText
      input.value = item.dataset.value      
      list.classList.remove('dropdown__list_visible')
      input.dispatchEvent(this.changeEvent)
      
    })
  }

  create() {

    this.selector.forEach((el) => {
      const dropdownBtn = el.querySelector('.dropdown__button');
      const dropdownList = el.querySelector('.dropdown__list');
      const dropdownItems = dropdownList.querySelectorAll('.dropdown__list_item');
      const dropdownInput = el.querySelector('.dropdown__input_hidden')
      //
      this.addBtnEventlistener(dropdownBtn, dropdownList)
      dropdownItems.forEach((item) => this.addItemEventlistener(dropdownList, item, dropdownBtn, dropdownInput, dropdownItems))

      document.addEventListener('click', (e) => {
        if (e.target !== dropdownBtn) {
          dropdownBtn.classList.remove('active');
          dropdownList.classList.remove('dropdown__list_visible');
        }
      })

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.key === 'Escape') {
          dropdownBtn.classList.remove('active');
          dropdownList.classList.remove('dropdown__list_visible');
        }
      })
    })

  }
}